<template>
  <div>
    <div class="bg" style="background-color:#E8E8E8"></div>
    <div class="u-hd">
        <div class="hd-bk" @click="closeModle">
            <i class="icon iconback"></i>&nbsp;返回
        </div>
        <div class="hd-tl">客户退货单详情</div>
        <div class="hd-mu">
            <div style="padding-left:48px"><i class="icon icongengduo2" @click="showShare=true"></i></div>
        </div>
    </div>
    <van-share-sheet
        v-model="showShare"
        title="立即分享给好友"
        :options="options"
        @select="onSelect"
    />
    <div style="height:44px"></div>
    <div style="display:flex;align-items: center;">
        <div style="padding:5px 10px;" :style="{color:form.state=='NOAUDIT'?'#FF8518':'#4935ae'}">
            <i class="icon icondanju" style="font-size:30px;"></i>
        </div>
        <div style="width:calc(100% - 90px);">
            <div class="add-ord-title" style="font-size:15px">客户退货单详情&nbsp;<span style="font-size:12px">({{form.no?form.no:'00000000000'}})</span></div> 
            <!-- <div class="add-ord-desc">
                <div>{{form.merchantName}}</div>
            </div> -->
        </div>
    </div>
    <div style="background:#fff;margin:0 13px;width:calc(100vw - 25px;);border-top-left-radius:5px;border-top-right-radius:5px;overflow:hidden">
      <div class="sum" style="display:flex;align-items: center;background-color:#4C37B6;padding:10px 0px">
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.stockCount | money}}</div>
                <div class="sum-txt">数量合计</div>
            </div>
            <div style="width:1px;height:20px;background:#8470e6"></div>
            <div style="text-align:center;color:#FFF;flex:1">
                <div class="sum-val">{{form.amountYuan | money}}</div>
                <div class="sum-txt">金额合计</div>
            </div>
        </div>
      <detali-table :isShow="isShow" :order="form" :details="details" bindchangeTable="changeState"></detali-table>
    </div>
    <div class="fixed-submit" style="width:calc(100vw - 25px);justify-content: flex-end;left:13px;background: #FFF;">
        <div style="width:100px;display:flex;" @click="goBack">
            <div class="btn" style="background-color:#ff8518;">
                <i class="icon iconfanhui1"></i>
                <div class="btn-text">返回</div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant';
import detailsTable from './detailsTable';
export default {
    components:{
        'detali-table':detailsTable
    },
    data() {
        return {
            form: {},
            details: [],
            active: 0,
            showShare:false,
            showBatchNoModel: false,
            state: 1,
            isShow: false,
            showPreOrderModel: false,
            moreKey: {},
            options: [
                { name: '微信', icon: 'wechat' },
                { name: '导出', icon: 'qrcode' },
            ],
            typeList: [],
            priceSetting: '',
            planappoint: '',
            plantype: '',
            planladder: '',
            plandiscount: ''
        }
    },
    created(){
        this.$request.get("storeOrder/orderDetail?orderId="+this.$route.query.orderId).then(data=>{
            this.form=data.content.storeOutInOrder
            this.details=data.content.detailList
        })
    },
    methods:{
        changeTab(name, title) {
            this.active=name
        },
        goBack(){
            this.router.go(-1)
        },
        save() {
            this.$request.post("purchaseOrder/handleOrder", {orderId:this.$route.query.orderId}).then(data => {
                if (data.status == 200) {
                    Toast("处理成功")
                    this.$request.get("purchaseOrder/orderDetail?orderId="+this.$route.query.orderId).then(data=>{
                        this.form=data.content.order
                        this.details=data.content.detailList
                    })
                } else {
                    Toast.fail(data.message);
                }
            })
        },
        closeModle(){
            this.router.go(-1)
        }
    }
}
</script>

<style>
.order-search{
  display: flex;
  padding: 5px 10px;
  height:50px;
  box-sizing: border-box;
  background-color: #FFF;
  align-items: center;
}
.order-search .search-input{
  width: calc(100% - 150px)
}
.order-search .search-input input{
  width: 100%;
  padding-left:5px;
  font-size: 14px;
  color:#888;
}
.order-search .search-icon{
  width: 150px;
  display: flex;
  height: 40px;
  box-sizing: border-box;
}
.order-search .search-icon .icon{
  font-size: 20px;
  color:#FFF;
}
.order-search .search-icon .icon-search{
  width: 75px;
  box-sizing: border-box;
  background-color: #486ad8;
  line-height: 40px;
  text-align: center;
}
.order-search .search-icon .icon-scan{
  width: 75px;
  color:#FFF;
  border-left: 1px solid #ccc;
  background-color: #486ad8;
  text-align: center;
  line-height: 40px;
  box-sizing: border-box;
}

.btns{
  display: flex;
  height: 50px;
  padding: 5px;
  line-height: 40px;
  box-sizing: border-box;
  background-color: #FFF;
}
.save{
  width: calc(50% - 10px);
  margin:0px 5px;
  text-align: center;
  
  font-size: 15px;
  background-color: #787CD2;
  color: #FFF;
}
.code{
  width: calc(50% - 10px);
  margin:0px 5px;
  font-size: 15px;
  text-align: center;
  background-color: #00B26A;
  color: #FFF;
}

.good-list-title{
  display:flex;
  border-bottom:1px solid #eee;
  font-size:15px;
  color:#333;
  height: 40px;
  line-height: 40px;
}
.good-list{
  /* padding:0rpx 10rpx; */
  font-size: 14px;
}
.good-list .good-item{
  display: flex;
  background-color:#FFF;
  margin-bottom: 5px;
  border-bottom: 1px solid #efefef;
  height: 30px;
  line-height: 30px;
}.good-list .list-item .item-index{
  background-color: #4935ae;
  color:#FFF;
  border-radius: 50%;
  display: inline-block;
  font-size: 12px;
  width: 23px;
  height: 23px;
  line-height: 23px;
  text-align: center;
}.good-list .list-item{
  margin-bottom: 5px;
  background-color: #FFF;
  color:#333;
  padding:10rpx 0rpx;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}
.good-list .list-item .item-index text{
  display: block;
  width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 50%;
  background-color: #486ad8;
  color: #FFF;
  text-align: center;
}
.good-list-price{
  text-align:left;
  font-size:14px;
  color:#4935ae;
}
.good-list .good-item .item-select{
  display: flex;
  justify-content: center;
  align-items: center;
  zoom: 0.8;
}
.good-item-detail{
  display: flex;
  align-items: center;
  background-color: #FFF;
  margin:5px;
}
.good-item-detail .item-select{
  width:40px;
  zoom: 0.8;
  text-align: center;
} 
.good-item-detail .item-box{
  width: calc(100% - 40px);
}
.good-item-detail .item-box .box-name{
  font-size:14px;
  color: #666;
  padding: 5px;
}
.good-item-detail .item-box .box-ck{
  display: flex;
  padding: 5px;
}
.good-item-detail .item-box .box-ck .box-code{
  width: 100px;
  font-size: 12px;
}
.good-item-detail .item-box .box-ck .box-keycode{
  width: calc(100% - 100px);
  font-size: 12px;
}
.good-list .good-item .text-center{
  font-size: 12px;
}
.good-list .good-item .row-cell{
  display: flex;
  height:25px;
  align-items: center;
  font-size: 12px;
}
.good-list .good-item .row-cell .item-left{
  flex:1;
      overflow: hidden;
  /*自动隐藏文字*/
  text-overflow: ellipsis;
  /*文字隐藏后添加省略号*/
  white-space: nowrap;
  /*强制不换行*/
}
.good-list .good-item .row-cell .item-right{
  flex:1;
  overflow: hidden;
  /*自动隐藏文字*/
  text-overflow: ellipsis;
  /*文字隐藏后添加省略号*/
  white-space: nowrap;
}
.good-list .good-item .row-cell .endNum{
      background-color: #2196f3;
      color: #FFF;
      padding: 5px 10px;
      border-radius: 50px;
}
.order-price{
  color:#F56C6C;
  font-weight: 600
}
</style>


// WEBPACK FOOTER //
// src/views/stockOutReport/detail.vue